export const LOGO_BG_COLOR_DEV = '#4ED4FF';
export const LOGO_BG_COLOR_STAGE = '#FF7D9C';
